import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DownloadDto } from '../_models/downloaddto';


@Injectable({
  providedIn: 'root'
})
export class DownloadService {
  baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getAll() {
    return this.http.get<DownloadDto[]>(this.baseUrl + 'download').pipe(
      map(downloads => {
        return downloads;
      })
    );
  }


}
